"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarProvider = exports.default = exports.Image = void 0;
var Image_1 = require("./Image");
Object.defineProperty(exports, "Image", { enumerable: true, get: function () { return __importDefault(Image_1).default; } });
var Avatar_1 = require("./Avatar");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Avatar_1).default; } });
var AvatarProvider_1 = require("./AvatarProvider");
Object.defineProperty(exports, "AvatarProvider", { enumerable: true, get: function () { return AvatarProvider_1.AvatarProvider; } });
//# sourceMappingURL=index.js.map